// 微服务名
const USER = 'user-center'
const STOCK = 'stock'
const JRJBASE = 'jrj-base'
const NEWS = '/jrj-news/'

export { USER, STOCK, JRJBASE, NEWS }
